"use client";

import { FetchButton } from "@/fetch-ui/FetchButton";
import { FetchInput } from "@/fetch-ui/FetchInput";
import { MAX_NAME_LENGTH } from "../_logic/constants";
import { WordleRules } from "./WordleRules";

interface WordleStartCardProps {
  name: string;
  onNameChange: (name: string) => void;
  onStart: () => void;
  starting: boolean;
}

/**
 * Name entry and rules, shown before the clock starts.
 * @param props The player's name, its setter, the start action and whether a start is in flight.
 * @returns The start card.
 */
export function WordleStartCard({ name, onNameChange, onStart, starting }: WordleStartCardProps) {
  return (
    <div className="flex flex-col gap-6">
      <form
        className="flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          onStart();
        }}
      >
        <label htmlFor="wordle-name" className="text-sm font-semibold text-slate-900">
          Your name, as it should appear on the leaderboard
        </label>
        <FetchInput
          id="wordle-name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="First and last name"
          maxLength={MAX_NAME_LENGTH}
          autoComplete="name"
          autoFocus
        />
        <FetchButton type="submit" variant="primary" size="lg" loading={starting} arrow className="w-full">
          Start the clock
        </FetchButton>
      </form>
      <div className="h-px bg-slate-200" />
      <WordleRules />
    </div>
  );
}
